<template>
  <div class="bulletin-box">
    <van-popup v-model="show" :style="{ height: '75vh', width: '90vw' }" round>
      <div class="close">
        <div style="float: right;">
        <van-checkbox style="margin: 0 auto;" v-model="checked" shape="square"
          >{{ $t('common.notshow') }}</van-checkbox
        >
        </div>
        <div style="clear: both;">
        <van-icon
          name="close"
          size="30"
          @click="ClosePopup"
          style="margin-top: 20px"
        />
        </div>
      </div>
      <div
        class="bulletin-context"
        v-if="
          this.wapConfig &&
          this.wapConfig.popup &&
          this.wapConfig.popup.title &&
          this.wapConfig.popup.title.length > 0
        "
      >
        <div class="title">{{ wapConfig.popup.title }}</div>
        <div class="context">
          <div style="width: 100%">
            <img :src="wapConfig.popup.img" style="width: 100%" />
          </div>
          <div style="clear: both" v-html="wapConfig.popup.content"></div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'BulletinView',
  data () {
    return {
      wapConfig: {},
      show: false,
      checked: false
    }
  },
  mounted () {
    this.getWapSetting()
  },
  methods: {
    ClosePopup () {
      this.show = false
      if (this.checked) {
        const today = new Date().toDateString()
        localStorage.setItem('dontShowToday', today)
      }
    },
    getWapSetting () {
      this.$http({
        method: 'get',
        url: 'getSetting'
      }).then(res => {
        this.wapConfig = res.data
        if (
          this.wapConfig &&
          this.wapConfig.popup &&
          this.wapConfig.popup.title &&
          this.wapConfig.popup.title.length > 0 &&
          !localStorage.getItem('dontShowToday')
        ) {
          this.show = true
        }
      })
    }
  }
}
</script>

<style></style>
